const lastPathIsEqual = (path, pathToValidate) => {
  if (!path || !pathToValidate) return false

  var splittedPath = path.split('/')
  var splittedPathToValidate = pathToValidate.split('/')

  return splittedPath[splittedPath.length - 1] === splittedPathToValidate[splittedPathToValidate.length - 1]
}

export { lastPathIsEqual }
